import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Document {
  document_id: string;
  document_type_id: string;
  title: string;
  description?: string;
  file_path: string;
  file_name: string;
  file_size_bytes: number;
  mime_type: string;
  site_id: string;
  tenant_id: string;
  portfolio_id?: string;
  created_by?: string;
  created_at: string;
  updated_at: string;
  status: string;
  document_type_name?: string;
  site_name?: string;
  uploaded_at?: string;
  uploaded_by?: string;
  tags?: Array<{ tag_category: string; tag_value: string }>;
}

export interface DocumentsState {
  documents: Document[];
  isLoading: boolean;
  error: string | null;
}

const initialState: DocumentsState = {
  documents: [],
  isLoading: false,
  error: null,
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setDocuments: (state, action: PayloadAction<Document[]>) => {
      state.documents = action.payload;
      state.error = null;
    },
    addDocument: (state, action: PayloadAction<Document>) => {
      state.documents.push(action.payload);
    },
    updateDocument: (state, action: PayloadAction<Document>) => {
      const index = state.documents.findIndex(doc => doc.document_id === action.payload.document_id);
      if (index !== -1) {
        state.documents[index] = action.payload;
      }
    },
    removeDocument: (state, action: PayloadAction<string>) => {
      state.documents = state.documents.filter(doc => doc.document_id !== action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setDocuments, addDocument, updateDocument, removeDocument, setLoading, setError } = documentsSlice.actions;
export default documentsSlice.reducer;

